export default __webpack_public_path__ + "static/media/26.528f8657.jpg";